import { render, staticRenderFns } from "./ArtigosImagePicker.vue?vue&type=template&id=13e27d85&scoped=true&"
import script from "./ArtigosImagePicker.vue?vue&type=script&lang=js&"
export * from "./ArtigosImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosImagePicker.vue?vue&type=style&index=0&id=13e27d85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e27d85",
  null
  
)

export default component.exports